import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    assestmenttitles:[]
}

export const fetchAssestmentTitle = createAsyncThunk('assestmenttitle/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/assestmentTitle`)
    return response.data
  })


let userSlice = createSlice({
  name:'assestmenttitle',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchAssestmentTitle.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchAssestmentTitle.fulfilled,(state,action)=>{
          state.isLoading = false
          state.assestmenttitles = action.payload
      })
      .addCase(fetchAssestmentTitle.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;